<template>
  <vl-layout>
    <vl-title id="vl-pt-cookie-consent__modal-title" tag-name="h2" tag-style="h6">
      <vl-link to="https://download.vlaanderen.be">Download.vlaanderen.be</vl-link> gebruikt cookies om uw surfervaring
      te verbeteren.
    </vl-title>
    <vl-grid mod-stacked>
      <vl-column>
        <vl-typography class="vl-u-text--medium">
          Sommige cookies zijn noodzakelijk om de website optimaal te laten functioneren. Andere cookies zijn optioneel
          en worden gebruikt om uw surfervaring op deze website te verbeteren. Als u op ‘Alle cookies aanvaarden’ klikt,
          aanvaardt u ook de optionele cookies. Wilt u liever zelf kiezen welke cookies u aanvaardt? Klik op
          ‘Cookievoorkeuren beheren’. Meer info leest u in het privacy- en
          <vl-link
            to="https://www.vlaanderen.be/digitaal-vlaanderen/onze-oplossingen/downloadtoepassing/algemene-gebruiksvoorwaarden#cookieverklaring"
            >cookiebeleid</vl-link
          >
          van <vl-link to="https://download.vlaanderen.be">Download.vlaanderen.be</vl-link>
        </vl-typography>
      </vl-column>
      <vl-column>
        <vl-action-group mod-collapse-s>
          <vl-button :test-id="`cookie-consent-all-save`" @click="consentAll"> Alle cookies aanvaarden </vl-button>
          <vl-button :test-id="`cookie-consent-required-save`" mod-secondary @click="consentRequired">
            Enkel noodzakelijke cookies aanvaarden
          </vl-button>
        </vl-action-group>
      </vl-column>
      <vl-column>
        <vl-accordion>
          <template v-slot:title>
            <span class="vl-u-text--medium" :test-id="`cookie-consent-manage`"> Cookievoorkeuren beheren </span>
          </template>
          <vl-form-grid mod-stacked>
            <vl-form-column>
              <vl-divider />
            </vl-form-column>
            <vl-form-column v-for="(option, index) in options" :key="index">
              <div>
                <vl-checkbox
                  v-model="option.checked"
                  :test-id="`cookie-consent-checkbox-${option.value}`"
                  :mod-disabled="option.disabled"
                  class="vl-checkbox"
                  type="checkbox"
                  name="consent"
                  mod-block
                  :value="option.value"
                >
                  {{ option.label }}
                </vl-checkbox>
                <vl-annotation class="vl-u-text--small">
                  {{ option.description }}
                </vl-annotation>
              </div>
            </vl-form-column>
            <vl-form-column>
              <vl-button :test-id="`cookie-consent-save`" @click="consent">Cookievoorkeuren opslaan</vl-button>
            </vl-form-column>
          </vl-form-grid>
        </vl-accordion>
      </vl-column>
    </vl-grid>
  </vl-layout>
</template>

<script lang="ts" src="./dl-cookie-consent.ts"></script>

<style lang="scss" scoped>
@use './dl-cookie-consent.scss';
</style>
